import api from './interceptor';

const BASE_URL_V2 = 'api/v2/invite';

export default {
  // API Version 2
  sendInvite: params => api.post(`${BASE_URL_V2}/send`, params),
  getInviteParams: params => api.get(`${BASE_URL_V2}/redeem`, { params }),
  getInviteeIceServers: params => api.get(`${BASE_URL_V2}`, { params }),
};
